import { render, staticRenderFns } from "./AuthWizard.vue?vue&type=template&id=1bb00fd7"
import script from "./AuthWizard.vue?vue&type=script&lang=js"
export * from "./AuthWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports